import { get } from 'lodash/fp';
import React from 'react';
import { ContactInfo } from './Contact.types';

export const PORTAL_REGISTRATION_STATUS_FIELD = 'portalRegistrationStatus';

export enum PortalRegistrationStatuses {
  PENDING = '1', // dropdown and portal message
  REGISTERED = '2', // dropdown and portal message
  APPROVED = '3',
  DENIED = '4', // dropdown
  INVITED = '6', // dropdown
}

export const useUserRegistrationStatus = (contactInfo: ContactInfo | null = null) => {
  return React.useMemo(() => {
    const status = get(PORTAL_REGISTRATION_STATUS_FIELD, contactInfo);

    return {
      isApproved: status === PortalRegistrationStatuses.APPROVED,
      isPending: status === PortalRegistrationStatuses.PENDING,
      isRegistered: status === PortalRegistrationStatuses.REGISTERED,
      isDenied: status === PortalRegistrationStatuses.DENIED,
      isInvited: status === PortalRegistrationStatuses.INVITED,
      statusCode: status || 0,
    };
  }, [contactInfo]);
};
